import "./styles.css";
import type { MarketLevelResult } from "@shared/labs/candidate-assessment";
import type { CorrectionCallback, ThreeAxisRecommendation } from "@shared/labs/three-axis";
import { AxesSection } from "./axes-section";
import { EvidencesSection } from "./evidences-section";
import { Hero } from "./hero";
import { SkillsSection } from "./skills-section";

export interface ThreeAxisReportProps {
  recommendation: ThreeAxisRecommendation;
  candidateName: string;
  discipline?: string;
  linkedinUrl?: string;
  /** Fired when CHRO saves an Ajustar panel; undefined = read-only mode. */
  onCorrection?: CorrectionCallback;
  /** Market-level inference result, if already computed. */
  marketLevel?: MarketLevelResult;
  /** Archived evaluation ID — enables the "Computar agora" re-run button. */
  archivedEvaluationId?: string;
  /** Fired when the re-run succeeds with the new result. */
  onMarketLevelComputed?: (result: MarketLevelResult) => void;
}

export function ThreeAxisReport({
  recommendation,
  candidateName,
  discipline,
  linkedinUrl,
  onCorrection,
  marketLevel,
  archivedEvaluationId,
  onMarketLevelComputed,
}: ThreeAxisReportProps) {
  return (
    <div className="three-axis-report">
      <Hero
        rec={recommendation}
        name={candidateName}
        discipline={discipline}
        linkedinUrl={linkedinUrl}
        marketLevel={marketLevel}
        archivedEvaluationId={archivedEvaluationId}
        onMarketLevelComputed={onMarketLevelComputed}
      />
      <EvidencesSection rec={recommendation} onCorrection={onCorrection} />
      <AxesSection rec={recommendation} onCorrection={onCorrection} />
      <SkillsSection rec={recommendation} onCorrection={onCorrection} discipline={discipline} />
    </div>
  );
}
